import { createStackNavigator, TransitionPresets } from '@react-navigation/stack';
import React from 'react';
import { applyOnPlatform } from '../helperFunctions';
import { dbPath } from '../typings/types';
import { DeepLinkingEntryScreen } from './DeepLinking';
import { CreateDialog, EditDialog } from './Dialogs';
import { Header } from './Header';
import { GroupStatementScreen } from './StatementView';
import { GroupsScreen } from './GroupsScreen';
import { GroupScreen } from './GroupScreen';
import { TopicScreen } from './TopicScreen';
import { ArgumentScreen } from './ArgumentScreen';
import { CoursesScreen } from './CoursesScreen';
import { CourseScreen } from './CourseScreen';

type FeedStackParamList = {
  feed: undefined;
  groups: undefined;
  learn: undefined;
  course: undefined;
  StatementView: { path: dbPath };
  SourceScreen: { path: dbPath };
  CreateDialog: undefined;
  DeepLinkingEntryScreen: undefined;
  DeepLinkingEntryScreenPersonal: undefined;
  DeepLinkingEntryScreenPublic: undefined;
  DeepLinkingEntryScreenGroup: undefined;
  DeepLinkingEntryScreenGroupInvite: undefined;
  DeepLinkingEntryScreenUser: undefined;
};

export function LearnMainScreen(): JSX.Element {
  const Stack = createStackNavigator<FeedStackParamList>();

  return (
    <Stack.Navigator
      initialRouteName="learn"
      screenOptions={navigationProps => Header(navigationProps)}
    >
      <Stack.Screen
        name="learn"
        component={CoursesScreen}
      />
      <Stack.Screen
        name="course"
        component={CourseScreen}
        options={applyOnPlatform({}, {
          ...TransitionPresets.SlideFromRightIOS,
        })}
      />
      <Stack.Screen
        name="DeepLinkingEntryScreenPublic"
        component={DeepLinkingEntryScreen}
        options={{
          animationEnabled: false,
        }}
      />
      <Stack.Screen
        name="DeepLinkingEntryScreenPersonal"
        component={DeepLinkingEntryScreen}
        options={{
          animationEnabled: false,
        }}
      />
      <Stack.Screen
        name="DeepLinkingEntryScreenGroup"
        component={DeepLinkingEntryScreen}
        options={{
          animationEnabled: false,
        }}
      />
      <Stack.Screen
        name="DeepLinkingEntryScreenGroupInvite"
        component={DeepLinkingEntryScreen}
        options={{
          animationEnabled: false,
        }}
      />
      <Stack.Screen
        name="DeepLinkingEntryScreenUser"
        component={DeepLinkingEntryScreen}
        options={{
          animationEnabled: false,
        }}
      />
    </Stack.Navigator>
  );
}